<template>
  <div >
    <v-card flat color="itoviBlueDarkest" class="login-header-card" >
      <h1 class="pt-4 pb-5" >Password Reset</h1>
    </v-card>

    <v-snackbar
        v-model="snackbar.error"
        color="error"
        :multi-line="true"
        :timeout="snackbar.timeout" >
      {{ snackbar.errorMessage }}
    </v-snackbar>
    <v-snackbar
        v-model="snackbar.success"
        color="success"
        :multi-line="true"
        :timeout="snackbar.timeout" >
      {{ snackbar.successMessage }}
    </v-snackbar>

    <LoadingDialog v-model="showLoadingDialog"></LoadingDialog>

    <v-layout>
      <v-flex xs12 sm8 md6 offset-sm2 offset-md3>
        <v-card color="#00000000" flat class="pl-5 pr-5 pt-5">

          <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
          >
            <v-text-field
                    v-model="email"
                    :rules="emailRules"
                    label="Email"
                    required
            ></v-text-field>

            <br/>
            <v-btn large round outline color="itoviBlue" @click="sendPasswordResetLink" >Send Password Reset Link</v-btn>
          </v-form>
        </v-card>

      </v-flex>
    </v-layout>




  </div>
</template>

<style lang="scss" scoped>
  .login-header-card {
    border-radius: 0;
  }
  h1 {
    color: white;
    font-family: 'IBM Plex Serif', serif;
    font-weight: 400;
    font-size: 32pt;
  }
</style>

<script>
  // import Api from '../services/api'
  import auth from '../auth'
  import api from '../services/api_endpoints'
  import LoadingDialog from "../components/LoadingDialog"

  export default {
    components: {
      LoadingDialog
    },
    data: () => ({
      showLoadingDialog: false,
      snackbar: {
        success: false,
        timeout: 2500,
        successMessage: `Email sent! Check the email provided.`,
      },
      valid: true,
      name: '',
      email: '',//'testing@oddmob.com',
      emailRules: [
        v => !!v || 'Email is required',
        v => /.+@.+/.test(v) || 'email must be valid'
      ],
      checkbox: false
    }),
    created () {
      if (auth.loggedIn())
        this.$router.replace('/')
    },
    methods: {
      async sendPasswordResetLink () {
        this.showLoadingDialog = true
        const emailSent = await api.sendPasswordReset(this.email)
        console.log('emailSent', emailSent)
        this.showLoadingDialog = false

        this.snackbar.success = true

      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
      validate () {
        this.$refs.form.validate()
      }
    }
  }
</script>
